import { FaGithub } from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi";
import { easyBanking, timeQuize, ExamSQAR } from "../../assets/index";

const AdvProject = () => {
  const projectList = [
    {
      img: ExamSQAR,
      title: "Online Exam Conductor - EaxmSQAR",
      techstack:
        " Reactjs, TypeScript, Nodejs, ExpressJs, MongoDb,  #Frontend   #Backend    #Web based application",
      live: "https://exam-sqar.vercel.app/",
      github: "https://github.com/Sastik/ExamSQAR",
    },
    {
      img: easyBanking,
      title: "Easy Banking",
      techstack:
        "JAVA Swing, Mysql #Frontend  #Backend  #Window based application ||  $deposit $withdrawal $fast cash $mini statement $pin change $balance inquiry",
      live: "https://github.com/Sastik/Easy-Banking",
      github: "https://github.com/Sastik/Easy-Banking",
    },
    {
      img: timeQuize,
      title: "Time Quize Website",
      techstack:
        "HTML, CSS, Javascript #Frontend  #Web based application || $countdown timer, $randomized questions, $user feedback, $start screen, $modal instructions.",
      live: "https://play-quize-project-sastik.netlify.app/",
      github: "https://github.com/Sastik/Quizer-website",
    },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-10">
      {projectList.map(({ img, live, github, title, techstack }, index) => (
        <div
          key={index}
          className="flex flex-col w-96 gap-2 bg-gray-50 drop-shadow-xl dark:bg-grey-800 rounded-lg p-4"
        >
          <div className="relative group rounded-lg bg-violet-50">
            <img
              alt={`Portfolio project - ${title}`}
              width={1000}
              height={1000}
              className="max-w-full h-48 max-h-full object-cover object-top rounded-lg"
              src={img}
              loading="lazy"
            />

            <div className="absolute top-0 scale-x-0 group-hover:scale-100 transition-transform origin-top duration-200 ease-linear bg-gray-800 bg-opacity-60 w-full h-full rounded-lg flex items-center gap-4 justify-center">
              <a
                href={live}
                className="bg-white text-black p-2 rounded-lg hover:bg-black hover:text-white transition-all"
              >
                <BiLinkExternal className="animate-pulse" size={20} />
              </a>
              <a
                href={github}
                className="bg-white text-black p-2 rounded-lg hover:bg-black hover:text-white transition-all"
              >
                <FaGithub className="animate-bounce" size={20} />
              </a>
            </div>
          </div>
          <div className="my-2 flex flex-col gap-3">
            <h3 className="text-xl text-center text-black font-medium">
              {title}
            </h3>
            <p className="text-sm font-semibold text-gray-600">
              <span className="font-medium">Tech Stack: </span>
              {techstack}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdvProject;
